module.exports = __webpack_public_path__ + "img/songfile-logo-color.99a4275b.svg";